module.exports = __webpack_public_path__ + "static/media/robot.410b80c5.svg";